import type { ReactElement } from 'react';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

export interface CloverOAuthConfirmationDialogProps {
    readonly open: boolean;
    readonly organizationUuid: string;
    readonly organizationName: string | null;
    readonly authorizationPath: string;
    readonly openInNewWindow: boolean;
    readonly onOpenChange: (open: boolean) => void;
}

export function CloverOAuthConfirmationDialog({
    open,
    organizationUuid,
    organizationName,
    authorizationPath,
    openInNewWindow,
    onOpenChange,
}: CloverOAuthConfirmationDialogProps): ReactElement {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-clover-organization-uuid={organizationUuid}>
                <DialogHeader>
                    <DialogTitle>Connect Clover</DialogTitle>
                    <DialogDescription>
                        Connect Clover to this Merchant Organization?
                    </DialogDescription>
                </DialogHeader>
                <p>{organizationName ?? organizationUuid}</p>
                {organizationName !== null && (
                    <p className="text-sm text-muted-foreground">{organizationUuid}</p>
                )}
                <DialogFooter>
                    <Button
                        type="button"
                        variant="outline"
                        data-clover-authorization-cancel="true"
                        onClick={() => onOpenChange(false)}
                    >
                        Cancel
                    </Button>
                    <Button type="button" asChild>
                        <a
                            href={authorizationPath}
                            target={openInNewWindow ? '_blank' : undefined}
                            onClick={(event) => {
                                onOpenChange(false);
                                if (!openInNewWindow) return;
                                // A script-opened window keeps its opener and can be closed
                                // by the completion route afterwards (BUG-278).
                                event.preventDefault();
                                window.open(authorizationPath, '_blank');
                            }}
                        >
                            OK
                        </a>
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
